import React from 'react';

import { Grid, TextField } from '@mui/material';
import { useFormContext } from 'react-hook-form';

import { Stack } from '@liscio/ui';

import { CreateAccountSectionProps } from './sectionTypes';
import { LabeledField, SubsectionTitle } from '../CreateAccountFormFieldPrimitives';
import { CreateAccountFormValues } from '../createAccountValidationSchema';

export const CreateAccountAddressFields: React.FC<CreateAccountSectionProps> = ({
  layout = 'responsive',
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<CreateAccountFormValues>();

  const cityBreakpoint = layout === 'single-column' ? 12 : 6;
  const stateZipBreakpoint = layout === 'single-column' ? 12 : 3;

  return (
    <Stack spacing={2}>
      <SubsectionTitle>Address</SubsectionTitle>
      <Grid container spacing={2.5} width="100%" sx={{ m: 0 }}>
        <Grid item xs={12}>
          <LabeledField label="Line 1">
            <TextField
              {...register('address_line_1')}
              fullWidth
              placeholder="123 Market St"
              error={Boolean(errors.address_line_1)}
              helperText={errors.address_line_1?.message}
              autoComplete="address-line1"
            />
          </LabeledField>
        </Grid>

        <Grid item xs={12}>
          <LabeledField label="Line 2">
            <TextField
              {...register('address_line_2')}
              fullWidth
              placeholder="Suite 400"
              error={Boolean(errors.address_line_2)}
              helperText={errors.address_line_2?.message}
              autoComplete="address-line2"
            />
          </LabeledField>
        </Grid>

        <Grid item xs={12} sm={cityBreakpoint}>
          <LabeledField label="City">
            <TextField
              {...register('address_city')}
              fullWidth
              placeholder="Austin"
              error={Boolean(errors.address_city)}
              helperText={errors.address_city?.message}
              autoComplete="address-level2"
            />
          </LabeledField>
        </Grid>

        <Grid item xs={12} sm={stateZipBreakpoint}>
          <LabeledField label="State">
            <TextField
              {...register('address_state')}
              fullWidth
              placeholder="TX"
              error={Boolean(errors.address_state)}
              helperText={errors.address_state?.message}
              autoComplete="address-level1"
            />
          </LabeledField>
        </Grid>

        <Grid item xs={12} sm={stateZipBreakpoint}>
          <LabeledField label="Zip">
            <TextField
              {...register('address_zip')}
              fullWidth
              placeholder="78701"
              error={Boolean(errors.address_zip)}
              helperText={errors.address_zip?.message}
              autoComplete="postal-code"
            />
          </LabeledField>
        </Grid>

        <Grid item xs={12}>
          <LabeledField label="Country">
            <TextField
              {...register('address_country')}
              fullWidth
              placeholder="United States"
              error={Boolean(errors.address_country)}
              helperText={errors.address_country?.message}
              autoComplete="country-name"
            />
          </LabeledField>
        </Grid>
      </Grid>
    </Stack>
  );
};

export default CreateAccountAddressFields;
